import Typography from "@mui/material/Typography";
import { currencyFormatter } from "../../../helpers";
import { PriceExtreme } from "./LineChart";

type ChartDetailsProps = {
  tickersData: PriceExtreme[];
};
const ChartDetails = ({ tickersData }: ChartDetailsProps) => {
  return (
    <div className="w-full flex flex-col justify-between items-center gap-y-4">
      {tickersData.map(({ ticker, startPrice, endPrice }, index) => (
        <div key={index} className="w-full flex items-center justify-between">
          <div className="font-semibold">
            {ticker ? ticker : "Key Metrics"}
          </div>

          <div className="flex gap-x-2 items-center">
            <Typography variant="body1/regular-nums" className="font-semibold">
              {currencyFormatter(endPrice)}
            </Typography>

            <div
              className={`flex gap-x-1 ${endPrice - startPrice > 0 ? "text-text-success-main" : "text-text-error-main"}`}
            >
              <Typography variant="body2/regular-400">
                {currencyFormatter(endPrice - startPrice)}
              </Typography>
              <Typography variant="body2/regular-400">
                (
                {(endPrice - startPrice > 0 ? "+" : "")
                + (((endPrice - startPrice) / startPrice) * 100).toFixed(2)}
                %)
              </Typography>
            </div>
          </div>

        </div>
      ))}
    </div>
  );
};
export default ChartDetails;
